import { USER_MANAGEMENT, USER_MANAGEMENT_V2 } from "api/ApiPath";
import {
  BaseApiResponseModel,
  Paging,
} from "api/baseApiResponseModel/BaseApiResponseModel";
import client from "api/client";
import { isEmpty } from "lodash";
import { injectable } from "tsyringe";
import { DataFormat } from "utils/format/DataFormat";
import { UserManagementRequestModel } from "./model/UserManagementRequest";
import { UserManagementResponseModel } from "./model/UserManagementResponse";
import { UserManagementCreateRequest } from "./model/createAction/UserManagementCreateRequest";
import { ResetPasswordRequest } from "./model/resetPassword/ResetPasswordRequest";
import { UserStatusUpdateRequestModel } from "./model/statusUpdate/UserStatusUpdateRequestModel";
import { UserStatusUpdateResponseModel } from "./model/statusUpdate/UserStatusUpdateResponseModel";
import { UserManagementUpdateRequest } from "./model/updateAction/UserManagementUpdateRequest";

export interface IUserManagementRepository {
  getUserList(params: UserManagementRequestModel): Promise<
    BaseApiResponseModel<{
      items: UserManagementResponseModel[];
      pagination: Paging;
    }>
  >;

  getUserListV2(params: UserManagementRequestModel): Promise<
    BaseApiResponseModel<{
      items: UserManagementResponseModel[];
      pagination: Paging;
    }>
  >;

  updateUser(
    body: UserManagementUpdateRequest
  ): Promise<BaseApiResponseModel<UserManagementResponseModel>>;

  createUser(
    body: UserManagementCreateRequest
  ): Promise<BaseApiResponseModel<UserManagementResponseModel>>;

  updateUserStatus(
    body: UserStatusUpdateRequestModel
  ): Promise<BaseApiResponseModel<UserStatusUpdateResponseModel>>;

  resetPassword(body: ResetPasswordRequest): Promise<BaseApiResponseModel<any>>;
}

@injectable()
export class UserManagementImpl implements IUserManagementRepository {
  async getUserList(params: UserManagementRequestModel): Promise<
    BaseApiResponseModel<{
      items: UserManagementResponseModel[];
      pagination: Paging;
    }>
  > {
    return await client.get(USER_MANAGEMENT?.USER_LIST, params);
  }

  async getUserListV2(params: UserManagementRequestModel): Promise<
    BaseApiResponseModel<{
      items: UserManagementResponseModel[];
      pagination: Paging;
    }>
  > {
    let queryString = Object?.entries(params)
      ?.filter(([_, vals]) => Array.isArray(vals))
      ?.map(([keys, vals]) => DataFormat.getQueryString(vals, keys))
      ?.join("&");
    Object?.entries(params)?.forEach(([keys, vals]) => {
      if (Array.isArray(vals)) {
        delete params[keys];
      } else {
        return;
      }
    });
    return await client.get(
      `${USER_MANAGEMENT_V2?.USER_LIST}${
        !isEmpty(queryString) ? `?${queryString}` : ""
      }`,
      params
    );
  }

  async updateUser(
    body: UserManagementUpdateRequest
  ): Promise<BaseApiResponseModel<UserManagementResponseModel>> {
    return await client.put(USER_MANAGEMENT?.UPDATE_USER, body);
  }

  async createUser(
    body: UserManagementCreateRequest
  ): Promise<BaseApiResponseModel<UserManagementResponseModel>> {
    return await client.post(USER_MANAGEMENT?.CREATE_USER, body);
  }

  async resetPassword(body: ResetPasswordRequest) {
    return await client.put(USER_MANAGEMENT?.RESET_PASSWORD, body);
  }

  async updateUserStatus(
    body: UserStatusUpdateRequestModel
  ): Promise<BaseApiResponseModel<UserStatusUpdateResponseModel>> {
    return await client?.put(USER_MANAGEMENT_V2.UPDATE_STATUS, body);
  }
}

export const defaultUserManagementRepository = new UserManagementImpl();
